<template>
  <nav class="al-navigation_container al-dynamic-flex">
    <section class="al-section-navigation-primary-nav">
      <a
        v-for="(section, index) in sections"
        :key="section.id || index"
        :href="section.link"
        class="al-section-link"
        :class="{ 'al-current-section-link': section.current }"
        test-id="horizontal-nav_item"
        @click.prevent="clickSection(section.id)"
      >
        {{ section.name }}
      </a>
    </section>
    <section class="al-section-navigation-secondary-nav">
      <!--
        @slot Container to add extra functions or actions
      -->
      <slot name="secondary" />
    </section>
  </nav>
</template>

<script>
/**
 * Menu navigation displayed horizontally, use for section navigation
 * or to render a sub menu; it just show links with pain text, but it
 * also have a slot to put inside extra components like buttons or
 * action icons.
 * @displayName al-horizontal-navigation
 */

export default {
  name: 'AlHorizontalNavigation',
  props: {
    /**
     * Array of javascript objects with menu items to show.
     * @values object keys: id, link, current(boolean), name
     */
    sections: {
      type: Array,
      required: true
    }
  },
  methods: {
    clickSection(sectionId) {
      /**
       * Event to emit when the user click over a link and return
       * which object was clicked
       * @property {string} playload String with the section id.
       */
      this.$emit('change-page', sectionId);
    }
  }
};
</script>

<style lang="scss" scoped>
.al-navigation_container {
  align-items: center;

  background-color: color(white, lighten, 1);

  border-bottom: solid 1px color(white, darken, 2);
  display: flex;
  flex-flow: row;

  font-weight: bold;
  height: 74px;
  justify-content: space-between;
  min-width: spacing(13);
  padding: 0 spacing(14);
  width: 100%;

  .al-section-navigation-secondary-nav {
    .al-section-navigation-secondary-nav-content {
      display: flex;
      margin-left: spacing(7);

      .al-secondary-nav-help-content {
        margin-left: spacing(4);
      }
    }
  }

  .al-section-link {
    color: color(black, lighten, 2);
    display: inline-block;
    font-size: font-size(s);
    height: spacing(13);
    line-height: spacing(13);
    margin-right: spacing(7);
    position: relative;
    text-decoration: none;
    text-transform: capitalize;

    &:hover {
      color: color(green);
    }

    &:active {
      color: color(green, darken, 1);
    }
  }

  .al-current-section-link,
  .al-section-link-active.nuxt-link-exact-active {
    color: color(green, darken, 1);

    &::after {
      border-bottom: solid 4px color(green, darken, 1);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      bottom: -2px;
      content: '';
      left: 0;
      position: absolute;
      width: 100%;
    }
  }
}
@media (max-width: 1060px) {
  .al-navigation_container {
    height: 60px;
    padding: 0 spacing(9);

    .al-section-link {
      font-size: font-size(xs);
      height: 58px;
      line-height: heading-line-height(h2);
      margin-right: spacing(3);
    }
  }
}
</style>
